"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Day = void 0;
const react_1 = __importDefault(require("react"));
const thresholdColors_1 = require("../../../../../utils/thresholdColors");
const S = __importStar(require("./Day.style"));
const Day = ({ dayNumber, value, onClick, isSelected, min, low, middle, high, max, }) => {
    return (react_1.default.createElement(S.Day, { "$isSelected": isSelected, onClick: value !== null ? onClick : undefined, "$color": (0, thresholdColors_1.getColorForValue)({ min, low, middle, high, max }, value), "$borderColor": (0, thresholdColors_1.getColorForValue)({ min, low, middle, high, max }, value, true), "$hasValue": value !== null, "data-testid": "calendar-cell" },
        react_1.default.createElement(S.DayNumber, { "$isVisible": true }, dayNumber),
        react_1.default.createElement(S.ValueContainer, { "$isVisible": true },
            react_1.default.createElement(S.Value, null, value !== null ? value : ""))));
};
exports.Day = Day;
